"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _LanguageProvider = require("./LanguageProvider");
var _CookieAgreementsProvider = require("./CookieAgreementsProvider");
var useAnalyticsAndCommerceTags = function useAnalyticsAndCommerceTags() {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements;
  var currencyList = global.__appConfig__.currencyList;
  var defaultCurrencyCode = currencyList && language.language && currencyList[language.language].code;
  var getBrandName = function getBrandName(technicalData) {
    var _producer$name;
    var producer = technicalData === null || technicalData === void 0 ? void 0 : technicalData.find(function (data) {
      return data.label === "brand" && data.name;
    });
    return (_producer$name = producer === null || producer === void 0 ? void 0 : producer.name) !== null && _producer$name !== void 0 ? _producer$name : null;
  };
  return {
    productVisited: function productVisited(product, categoryName) {
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var _product$producer, _product$info;
        gtag("event", "view_item", {
          currency: defaultCurrencyCode,
          value: product.price.special ? product.price.special : product.price.regular,
          items: [{
            item_id: product.sku,
            item_name: product.name,
            affiliation: "Dajar",
            discount: product.price.special ? product.price.regular - product.price.special : 0,
            item_brand: (_product$producer = product.producer) !== null && _product$producer !== void 0 ? _product$producer : getBrandName((_product$info = product.info) === null || _product$info === void 0 ? void 0 : _product$info.technicalData),
            item_category: categoryName,
            item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
            quantity: 1
          }]
        });
      }
      global.__appConfig__.facebookEnabled && (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && fbq("track", "ViewContent", {
        content_type: "product",
        content_ids: [product.sku]
      });
    },
    viewList: function viewList(products) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var listType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      global.__appConfig__.facebookEnabled && (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && fbq("track", "ViewContent", {
        content_type: "category",
        content_ids: products.map(function (product) {
          return product.sku;
        })
      });
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      var listProducts = products.map(function (product, index) {
        var _product$producer2, _product$info2;
        return {
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          currency: defaultCurrencyCode,
          discount: product.price.special ? product.price.regular - product.price.special : 0,
          index: index,
          item_brand: (_product$producer2 = product.producer) !== null && _product$producer2 !== void 0 ? _product$producer2 : getBrandName((_product$info2 = product.info) === null || _product$info2 === void 0 ? void 0 : _product$info2.technicalData),
          item_category: name,
          item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
          price: product.price.special ? product.price.special : product.price.regular,
          quantity: 1
        };
      });
      global.__appConfig__.promotionCategory === id ? gtag("event", "select_promotion", {
        promotion_id: id,
        promotion_name: "sale",
        items: listProducts
      }) : gtag("event", "view_item_list", {
        item_list_id: id,
        item_list_name: name,
        items: listProducts
      });
    },
    productClicked: function productClicked(product, category, listName, listPosition) {
      var _category, _product$producer3, _product$info3;
      var listId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      category = (_category = category) !== null && _category !== void 0 ? _category : "";
      gtag("event", "select_item", {
        item_list_id: listId,
        item_list_name: category,
        // list_name
        items: [{
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          discount: product.price.special ? product.price.regular - product.price.special : 0,
          index: listPosition !== null && listPosition !== void 0 ? listPosition : "",
          item_brand: (_product$producer3 = product.producer) !== null && _product$producer3 !== void 0 ? _product$producer3 : getBrandName((_product$info3 = product.info) === null || _product$info3 === void 0 ? void 0 : _product$info3.technicalData),
          item_category: category,
          item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
          price: product.price.special ? product.price.special : product.price.regular,
          quantity: 1
        }]
      });
    },
    viewCart: function viewCart(cartContent) {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      var cartValue = 0;
      var cartItems = [];
      cartContent === null || cartContent === void 0 ? void 0 : cartContent.forEach(function (product, index) {
        var _product$product, _product$product$pric, _product$product2, _product$product2$pri, _product$product3, _product$producer4, _product$product4, _product$product4$inf, _product$product5, _product$product5$pic, _product$product6, _product$product7, _product$product8;
        cartValue += product !== null && product !== void 0 && (_product$product = product.product) !== null && _product$product !== void 0 && (_product$product$pric = _product$product.price) !== null && _product$product$pric !== void 0 && _product$product$pric.special ? parseFloat(product.product.price.special) * parseInt(product.quantity) : parseFloat(product === null || product === void 0 ? void 0 : (_product$product2 = product.product) === null || _product$product2 === void 0 ? void 0 : (_product$product2$pri = _product$product2.price) === null || _product$product2$pri === void 0 ? void 0 : _product$product2$pri.regular) * parseInt(product === null || product === void 0 ? void 0 : product.quantity);
        cartItems.push({
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          currency: defaultCurrencyCode,
          discount: (_product$product3 = product.product) !== null && _product$product3 !== void 0 && _product$product3.price.special ? product.product.price.regular - product.product.price.special : 0,
          index: index,
          item_brand: (_product$producer4 = product === null || product === void 0 ? void 0 : product.producer) !== null && _product$producer4 !== void 0 ? _product$producer4 : getBrandName((_product$product4 = product.product) === null || _product$product4 === void 0 ? void 0 : (_product$product4$inf = _product$product4.info) === null || _product$product4$inf === void 0 ? void 0 : _product$product4$inf.technicalData),
          item_variant: ((_product$product5 = product.product) === null || _product$product5 === void 0 ? void 0 : (_product$product5$pic = _product$product5.pickedOptions) === null || _product$product5$pic === void 0 ? void 0 : _product$product5$pic.length) > 0 ? product.product.pickedOptions[0].name : "",
          price: product !== null && product !== void 0 && (_product$product6 = product.product) !== null && _product$product6 !== void 0 && _product$product6.price.special ? product === null || product === void 0 ? void 0 : (_product$product7 = product.product) === null || _product$product7 === void 0 ? void 0 : _product$product7.price.special : product === null || product === void 0 ? void 0 : (_product$product8 = product.product) === null || _product$product8 === void 0 ? void 0 : _product$product8.price.regular,
          quantity: product.quantity
        });
      });
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "view_cart", {
        currency: defaultCurrencyCode,
        value: cartValue,
        items: cartItems
      });
    },
    productAddedToCart: function productAddedToCart(product, quantity, categoryName, currency) {
      var listId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var listType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
      var listPosition = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var _product$producer5, _product$info4;
        gtag("event", "add_to_cart", {
          currency: defaultCurrencyCode,
          value: product.price.special ? product.price.special * quantity : product.price.regular * quantity,
          items: [{
            item_id: product.sku,
            item_name: product.name,
            affiliation: "Dajar",
            currency: defaultCurrencyCode,
            discount: product.price.special ? product.price.regular - product.price.special : 0,
            index: listPosition,
            item_brand: (_product$producer5 = product === null || product === void 0 ? void 0 : product.producer) !== null && _product$producer5 !== void 0 ? _product$producer5 : getBrandName((_product$info4 = product.info) === null || _product$info4 === void 0 ? void 0 : _product$info4.technicalData),
            item_category: categoryName,
            item_list_id: listId,
            item_list_name: listType,
            item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
            price: product.price.special ? product.price.special : product.price.regular,
            quantity: quantity
          }]
        });
      }
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && global.__appConfig__.facebookEnabled && fbq("track", "AddToCart", {
        content_ids: [product.sku],
        content_name: product.name,
        currency: currency !== null && currency !== void 0 ? currency : defaultCurrencyCode,
        value: product.price.special ? product.price.special : product.price.regular
      });
    },
    checkoutBegin: function checkoutBegin(cart, coupon) {
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        gtag("event", "begin_checkout", {
          currency: defaultCurrencyCode,
          value: cart.totals.cartTotalPrice,
          coupon: coupon !== null && coupon !== void 0 ? coupon : "",
          items: cart.items.filter(function (item) {
            return item === null || item === void 0 ? void 0 : item.product;
          }).map(function (item) {
            var _item$product, _item$product2, _item$product$produce, _item$product3, _item$product3$info;
            return {
              item_id: item.sku,
              item_name: item.name,
              affiliation: "Dajar",
              quantity: item.quantity,
              price: (_item$product = item.product) !== null && _item$product !== void 0 && _item$product.price.special ? item.product.price.special : item.product.price.regular,
              discount: (_item$product2 = item.product) !== null && _item$product2 !== void 0 && _item$product2.price.special ? item.product.price.regular - item.product.price.special : 0,
              item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : "",
              item_brand: (_item$product$produce = item.product.producer) !== null && _item$product$produce !== void 0 ? _item$product$produce : getBrandName((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : (_item$product3$info = _item$product3.info) === null || _item$product3$info === void 0 ? void 0 : _item$product3$info.technicalData)
            };
          })
        });
      }
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.pixelFb) {
        global.__appConfig__.facebookEnabled && fbq("track", "InitiateCheckout");
      }
    },
    cartPurchased: function cartPurchased(cart, checkout, language, order, coupon) {
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var _window;
        var dataLayer = ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer) || [];
        dataLayer.push({
          purchasedCartInfo: {
            email: cart.billingAddress.email,
            phone_number: cart.billingAddress.phone,
            first_name: cart.billingAddress.firstName,
            last_name: cart.billingAddress.lastName,
            home_address: {
              street: cart.billingAddress.street,
              city: cart.billingAddress.city,
              region: "",
              postal_code: cart.billingAddress.postalCode,
              country: cart.billingAddress.country.id
            }
          }
        });
        gtag("event", "purchase", {
          transaction_id: order,
          affiliation: "Dajar",
          value: checkout.totalPrice,
          tax: cart.totals.tax,
          shipping: checkout.shippingTotal,
          currency: cart.currency,
          coupon: coupon !== null && coupon !== void 0 ? coupon : "",
          items: cart.items.filter(function (item) {
            return item === null || item === void 0 ? void 0 : item.product;
          }).map(function (item, index) {
            var _item$product4, _item$product5, _item$product$produce2, _item$product6, _item$product6$info;
            return {
              item_id: item.sku,
              item_name: item.name,
              affiliation: "Dajar",
              quantity: item.quantity,
              price: (_item$product4 = item.product) !== null && _item$product4 !== void 0 && _item$product4.price.special ? item.product.price.special : item.product.price.regular,
              currency: cart.currency,
              discount: (_item$product5 = item.product) !== null && _item$product5 !== void 0 && _item$product5.price.special ? item.product.price.regular - item.product.price.special : 0,
              index: index,
              item_brand: (_item$product$produce2 = item.product.producer) !== null && _item$product$produce2 !== void 0 ? _item$product$produce2 : getBrandName((_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : (_item$product6$info = _item$product6.info) === null || _item$product6$info === void 0 ? void 0 : _item$product6$info.technicalData),
              item_category: item.categoryName,
              item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : ""
            };
          })
        });
      }
      global.__appConfig__.facebookEnabled && (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && fbq("track", "Purchase", {
        transaction_id: order,
        value: checkout.totalPrice,
        currency: cart.currency,
        content_type: "product",
        contents: cart.items.map(function (item) {
          return {
            id: item.sku,
            quantity: item.quantity
          };
        })
      });
    },
    productRemovedFromCart: function productRemovedFromCart(product) {
      var _product$producer6, _product$info5;
      var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var quantity = arguments.length > 2 ? arguments[2] : undefined;
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "remove_from_cart", {
        currency: defaultCurrencyCode,
        value: product.price.special ? product.price.special : product.price.regular,
        items: [{
          item_id: product.sku,
          item_name: product.name,
          affiliation: "Dajar",
          currency: defaultCurrencyCode,
          discount: product.price.special ? product.price.regular - product.price.special : 0,
          item_brand: (_product$producer6 = product.producer) !== null && _product$producer6 !== void 0 ? _product$producer6 : getBrandName((_product$info5 = product.info) === null || _product$info5 === void 0 ? void 0 : _product$info5.technicalData),
          item_category: category,
          item_list_name: "cart",
          item_variant: product.pickedOptions.length > 0 ? product.pickedOptions[0].name : "",
          price: product.price.special ? product.price.special : product.price.regular,
          quantity: quantity
        }]
      });
    },
    setCheckoutOption: function setCheckoutOption(step, option, value, cart) {
      var methods = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var coupon = arguments.length > 5 ? arguments[5] : undefined;
      if (cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics) {
        var selectedMethod = methods.find(function (method) {
          return (method === null || method === void 0 ? void 0 : method.methodCode) === value;
        });
        if (step === 2 && option === "shipping method") {
          gtag("event", "add_shipping_info", {
            shipping_tier: value,
            value: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.price,
            currency: cart.currency,
            coupon: coupon !== null && coupon !== void 0 ? coupon : "",
            items: cart.items.filter(function (item) {
              return item === null || item === void 0 ? void 0 : item.product;
            }).map(function (item, index) {
              var _item$product7, _item$product8, _item$product$produce3, _item$product9, _item$product9$info, _item$categoryName;
              return {
                item_id: item.sku,
                item_name: item.name,
                affiliation: "Dajar",
                quantity: item.quantity,
                price: (_item$product7 = item.product) !== null && _item$product7 !== void 0 && _item$product7.price.special ? item.product.price.special : item.product.price.regular,
                currency: cart.currency,
                discount: (_item$product8 = item.product) !== null && _item$product8 !== void 0 && _item$product8.price.special ? item.product.price.regular - item.product.price.special : 0,
                index: index,
                item_brand: (_item$product$produce3 = item.product.producer) !== null && _item$product$produce3 !== void 0 ? _item$product$produce3 : getBrandName((_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : (_item$product9$info = _item$product9.info) === null || _item$product9$info === void 0 ? void 0 : _item$product9$info.technicalData),
                item_category: (_item$categoryName = item.categoryName) !== null && _item$categoryName !== void 0 ? _item$categoryName : "",
                item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : ""
              };
            })
          });
        }
        if (step === 3 && option === "payment method") {
          gtag("event", "add_payment_info", {
            payment_type: value,
            currency: cart.currency,
            coupon: coupon !== null && coupon !== void 0 ? coupon : "",
            items: cart.items.filter(function (item) {
              return item === null || item === void 0 ? void 0 : item.product;
            }).map(function (item, index) {
              var _item$product0, _item$product1, _item$product$produce4, _item$product10, _item$product10$info, _item$categoryName2;
              return {
                item_id: item.sku,
                item_name: item.name,
                affiliation: "Dajar",
                quantity: item.quantity,
                price: (_item$product0 = item.product) !== null && _item$product0 !== void 0 && _item$product0.price.special ? item.product.price.special : item.product.price.regular,
                currency: cart.currency,
                discount: (_item$product1 = item.product) !== null && _item$product1 !== void 0 && _item$product1.price.special ? item.product.price.regular - item.product.price.special : 0,
                index: index,
                item_brand: (_item$product$produce4 = item.product.producer) !== null && _item$product$produce4 !== void 0 ? _item$product$produce4 : getBrandName((_item$product10 = item.product) === null || _item$product10 === void 0 ? void 0 : (_item$product10$info = _item$product10.info) === null || _item$product10$info === void 0 ? void 0 : _item$product10$info.technicalData),
                item_category: (_item$categoryName2 = item.categoryName) !== null && _item$categoryName2 !== void 0 ? _item$categoryName2 : "",
                item_variant: item.product.pickedOptions.length > 0 ? item.product.pickedOptions[0].name : ""
              };
            })
          });
        }
      }
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && global.__appConfig__.facebookEnabled && step === 3 && fbq("track", "AddPaymentInfo", {
        content_ids: [value]
      });
    },
    setProductOption: function setProductOption() {
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && global.__appConfig__.facebookEnabled && fbq("track", "CustomizeProduct");
    },
    searchPhrase: function searchPhrase(phrase) {
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.analytics) && gtag("event", "search", {
        search_term: phrase
      });
      (cookieAgreements === null || cookieAgreements === void 0 ? void 0 : cookieAgreements.pixelFb) && global.__appConfig__.facebookEnabled && fbq("track", "Search", {
        search_string: phrase
      });
    },
    selectContent: function selectContent(type, id) {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "select_content", {
        content_type: type,
        item_id: id
      });
    },
    logIn: function logIn() {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "login", {
        method: "Form"
      });
    },
    signUp: function signUp() {
      if (!(cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.analytics)) return;
      gtag("event", "sign_up", {
        method: "Form"
      });
    }
  };
};
var _default = useAnalyticsAndCommerceTags;
exports["default"] = _default;